import React from 'react';
import { FaExclamationTriangle } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';

const PermissionDenied: React.FC = () => {
    const { t } = useTranslation();

    return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-gray-200">
            <div className="bg-white p-10 rounded-lg shadow-lg text-center">
                <FaExclamationTriangle className="text-red text-6xl mb-4 mx-auto" />
                <h1 className="text-3xl font-bold text-red mb-2">
                    {t('access_denied.title')}
                </h1>
                <p className="text-lg text-gray-700">
                    {t('access_denied.description')}
                </p>
            </div>
        </div>
    );
};

export default PermissionDenied;
